import SelectPassenger from './SelectPassenger';

export default SelectPassenger;
